<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchApplications(per_page, page, status) {
    return axios.get(`requerimentos?per_page=${per_page}&page=${page}&status=${status}`, AS.getDefaultHeaders());
  },
  searchApplications(per_page, page, search) {
    return axios.post(`requerimentos/search`, {per_page :per_page, page: page, search: search },  AS.getDefaultHeaders());
  },
  // searchAdminApplications(per_page, page, status) {
  //   return axios.get(`admin/requerimentos/search?per_page=${per_page}&page=${page}&status=${status}&search=${search}`, AS.getDefaultHeaders());
  // },
  fetchApplication(id) {
    return axios.get(`requerimentos/${id}`, AS.getDefaultHeaders());
  },
  adminFetchApplications(per_page, page, status) {
    return axios.get(`admin/requerimentos/pending_analysis?per_page=${per_page}&page=${page}&status=${status}`, AS.getDefaultHeaders());
  },
  adminFetchApplication(id) {
    return axios.get(`admin/requerimentos/${id}`, AS.getDefaultHeaders());
  },
  createApplication(applicationAttributes) {
    return axios.post('requerimentos', { application: applicationAttributes }, AS.getDefaultHeaders());
  },
  fetchSubpoenaedApplication(folderNumber) {
    return axios.post('admin/requerimentos/find_by_folder_number', { folder_number: folderNumber }, AS.getDefaultHeaders());
  },
  fetchPaymentSlipValue({applicationTypeId, degradingPotentialForTaxId,
    sizeForTaxId, analysisType, isSocialInterest, isProcessReanalysis, isOwnershipChange, enquadramento, qualifyForLac}) {
    return axios.post('requerimentos/payment_slip_value',
      {
        enquadramento,
        application_type_id: applicationTypeId,
        degrading_potential_for_tax_id: degradingPotentialForTaxId,
        size_for_tax_id: sizeForTaxId,
        is_social_interest: isSocialInterest,
        is_process_reanalysis: isProcessReanalysis,
        is_ownership_change: isOwnershipChange,
        analysis_type_id: analysisType,
        qualify_for_lac: qualifyForLac
      }, AS.getDefaultHeaders());
  },
  sendApplicationToReview(application) {
    return axios.get(`requerimentos/${application.id}/send_to_review`, AS.getDefaultHeaders());
  },
  startAnalysis(id) {
    return axios.post('admin/requerimentos/start_analysis_application', { id }, AS.getDefaultHeaders());
  },
  finishReview(application) {
    return axios.get(`admin/requerimentos/${application.id}/finish_review`, AS.getDefaultHeaders());
  },
  reEmissionPaymentSlip(processingNumber) {
    return axios.post('requerimentos/payment_slip/re_emission',
      { processing_number: processingNumber },
      AS.getDefaultHeaders());
  },
  updatePaymentSlipStatus(processingNumber) {
    return axios.get(`admin/requerimentos/payment_slip_status_update/?processing_number=${processingNumber}`, AS.getDefaultHeaders());
  },
  createSubpoena(applicationId, intimation) {
    return axios.post(`admin/requerimentos/${applicationId}/intimations`, { intimation }, AS.getDefaultHeaders());
  },
  showReceipt(applicationId) {
    return axios.get(`requerimentos/${applicationId}/show_receipt`, AS.getDefaultHeaders());
  },
  showHistoric(folderNumber, cpfCnpj) {
    return axios.post('requerimentos/show_timeline', { process_number: folderNumber, cpf_cnpj: cpfCnpj }, AS.getDefaultHeaders());
  },
  showHistoricNoAuthenticated(folderNumber, cpfCnpj) {
    return axios.post('requerimentos/show_timeline_no_authentication_required', { process_number: folderNumber, cpf_cnpj: cpfCnpj });
  },
  destroy(applicationId) {
    return axios.delete(`requerimentos/${applicationId}`, AS.getDefaultHeaders());
  },
  search(query) {
    return axios.get(`requerimentos/search?query=${query}`, AS.getDefaultHeaders());
  },
};
</script>
